module.exports = __webpack_public_path__ + "assets/img/zawadi.5157ea1e.png";